module.exports = __webpack_public_path__ + "static/media/sketch_2_small.049c206e.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/sketch_2_small.png
// module id = 535
// module chunks = 0